import logo from '../assets/ikifriki-logo.svg';

export const imgMainLogo = logo;
